"use strict";
/**
 * 指纹灰度计算器
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fingerprintValid = void 0;
function fingerprintValid() {
    return true;
    // //b9ecc5721594c490392c36612165d771
    // //1db71f5f1963fa416c5f64a5f5bad65e
    // let qgqp_b_id = cookie.get('qgqp_b_id')
    // if(qgqp_b_id && qgqp_b_id.length == 32){
    //   if(qgqp_b_id == 'b9ecc5721594c490392c36612165d771' || qgqp_b_id == '1db71f5f1963fa416c5f64a5f5bad65e'){
    //     return true
    //   }
    //   try {
    //     if(parseInt(qgqp_b_id, 16) % 10 <= 5){ // 转成十进制 余数 十分之六
    //       return true
    //     }
    //   } catch (error) {
    //   }
    // }
    // return false
}
exports.fingerprintValid = fingerprintValid;
